import { render, staticRenderFns } from "./ControlDrug.vue?vue&type=template&id=65180846"
import script from "./ControlDrug.vue?vue&type=script&lang=js"
export * from "./ControlDrug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports